import styled from 'styled-components';
import Input from '@components/Input';

const StyledInput = styled(Input)`
  & p {
    max-width: 80%;
  }
`;

export default StyledInput;
